export function getQueryVariable(variable) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == variable) {
      return decodeURIComponent(pair[1]).replaceAll('+', ' ')
    }
  }
  return false
}

export function getPathname() {
  const query = window.location.pathname
  const vars = query.split('/')

  return vars[1] && vars[1]
}
